import { Injectable, effect, inject } from '@angular/core';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import { AnalyticsService } from './analytics.service';
import { environment } from '../../../environments/environment';

interface KeycloakTokenParsed {
    sub?: string;
    resource_access?: Record<string, { roles?: string[] }>;
}

@Injectable({ providedIn: 'root' })
export class UserTrackingService {
    private readonly analytics = inject(AnalyticsService);
    private readonly kcEvent = inject(KEYCLOAK_EVENT_SIGNAL);
    private readonly keycloak = inject(Keycloak);

    private started = false;
    private identified = false;

    constructor() {
        effect(() => {
            const ev = this.kcEvent();
            if (!this.started) return;
            if (ev.type === KeycloakEventType.AuthSuccess || ev.type === KeycloakEventType.Ready) {
                this.maybeIdentify();
            }
            if (ev.type === KeycloakEventType.AuthLogout) {
                this.identified = false;
            }
        });
    }

    start(): void {
        this.started = true;
        this.maybeIdentify();
    }

    private maybeIdentify(): void {
        if (this.identified) return;
        const parsed = this.keycloak.tokenParsed as KeycloakTokenParsed | undefined;
        const sub = parsed?.sub;
        if (!sub) return;

        const clientId = environment.keycloak.config.clientId;
        const roles = parsed?.resource_access?.[clientId]?.roles ?? [];

        this.analytics.identify(sub, roles.length > 0 ? { roles } : undefined);
        this.analytics.track('login', { method: 'keycloak' });
        this.identified = true;
    }
}
